export enum HealthReportsMutations {
    SET_REPORTS_VIEW = 'SET_REPORTS_VIEW',
    SET_MANAGEMENT_VIEW = 'SET_MANAGEMENT_VIEW',
    SELECT_CUSTOMER = 'SELECT_CUSTOMER',
}
